import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ProgressBar = ({ progress = 100, height = 10, borderRadius = 16, className }) => {
  const containerStyle = {
    borderRadius,
    height,
  };
  const barStyle = {
    width: `${progress}%`,
    borderRadius,
    height,
  };

  const containerClassName = classNames({
    'progress-bar__container': true,
    [className]: !!className,
  });

  return <div
    className={containerClassName}
    style={containerStyle}
  >
    <div
      className="progress-bar__bar"
      style={barStyle}
    />
  </div>;
};

ProgressBar.propTypes = {
  progress: PropTypes.number,
  height: PropTypes.number,
  borderRadius: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressBar;
